"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function withTimeout(p, ms, fallback) {
    var t;
    var timeout = new Promise(function (resolve) { return t = setTimeout(function () { return resolve(fallback); }, ms); });
    return Promise.race([p, timeout]).finally(function () { return clearTimeout(t); });
}
exports.withTimeout = withTimeout;
